import React from "react";
import ImageUploading from "react-images-uploading";
import { Button } from "@mui/material";

export default function ImageUpload({ onImageSelect, className }) {
  const maxNumber = 1;

  return (
    <ImageUploading
      onChange={onImageSelect}
      maxNumber={maxNumber}
      dataURLKey="data_url"
    >
      {({ onImageUpload }) => (
        <>
          {className ? (
            <button onClick={onImageUpload} className={className}>
              Upload your Photo
            </button>
          ) : (
            <Button onClick={onImageUpload} variant="text" size="small">
              Upload your Photo
            </Button>
          )}
        </>
      )}
    </ImageUploading>
  );
}
